
export const USE_LIBRARY_INDICATORS = true;

/**
 * Check if a specific indicator should use the library approach
 * 
 * Some indicators MUST use the old AlphaVantage approach:
 * - STD_DEV_LEVELS: Custom backend calculation
 * - LIQUIDITY / LIQUIDITY_CANDLE: Pseudo-indicators (order book overlays, not series)
 * 
 * DEMA and TEMA are now calculated locally using EMA combinations!
 */
export function shouldUseLibrary(indicatorType) {
  // These indicators MUST use the old approach or a dedicated fetch path
  const mustUseOldApproach = ['STD_DEV_LEVELS', 'LIQUIDITY', 'LIQUIDITY_CANDLE', 'TF_MA'];
  
  if (mustUseOldApproach.includes(indicatorType)) {
    return false;
  }
  
  // For all other indicators (including DEMA/TEMA now!), respect the feature flag
  return USE_LIBRARY_INDICATORS;
}

/**
 * Get a display label for the current approach
 */
export function getIndicatorApproachLabel() {
  return USE_LIBRARY_INDICATORS ? 'Library (New)' : 'AlphaVantage (Legacy)';
}

